import {
    GET_ALL_PRIZES,
    ADD_PRIZE,
    EDIT_PRIZE,
    DELETE_PRIZE
} from '../actions/PrizeActions'

const initialState = {
    data: [],
    allPrizes: [],
    totalPrizes: 0,
    totalPages: 0,
    currentPage: 1,

    latestUpdate: '',
    loading: false,
    error: '',
}

const PrizeReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_PRIZE: {
            let tempArray = Object.assign({}, state.allPrizes)
            tempArray.rows = [action.payload, ...state.allPrizes.rows]
            return {
                ...state,
                allPrizes: tempArray,
            }
        }
        case EDIT_PRIZE: {
            let tempArray = Object.assign({}, state.allPrizes)
            let target = tempArray.rows.findIndex(item => {return item.id == action.payload.id})
            tempArray.rows[target] = action.payload            
            return {
                ...state,
                allPrizes: tempArray,
            }
        }
        case DELETE_PRIZE: {
            let tempArray = Object.assign({}, state.allPrizes)
            let newArray = tempArray.rows.filter(item => {return item.id !== action.payload})
            tempArray.rows = newArray            
            return {
                ...state,
                allPrizes: tempArray,
            }
        }
        case GET_ALL_PRIZES: {
            return {
                ...state,
                data: action.payload.prizes.prizes,
                currentPage: action.payload.prizes.currentPage,
                totalPrizes: action.payload.prizes.totalElements,
                totalPages: action.payload.prizes.totalPages,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default PrizeReducer
